import styled from 'styled-components';
import img from './img/checkmark_light.svg';
export var Input = styled.div.withConfig({
  displayName: "style__Input",
  componentId: "gjrao4-0"
})(["width:17px;margin:auto;height:17px;cursor:pointer;font-weight:bold;position:absolute;border-radius:4px;background-size:75%;display:inline-block;background-position:center;background-repeat:no-repeat;background-image:url(", ");border:", ";background-color:", ";"], img, function (props) {
  return props.checked ? 'none' : '1px solid #c4c4bf';
}, function (props) {
  return props.color && props.checked ? props.color : '#fff';
});